export const GET_FACILITY_USERS_REQUESTED = "GET_FACILITY_USERS_REQUESTED";
export const GET_FACILITY_USERS_SUCCEEDED = "GET_FACILITY_USERS_SUCCEEDED";
export const GET_FACILITY_USERS_FAILED = "GET_FACILITY_USERS_FAILED";
